// extracted by mini-css-extract-plugin
export var icon = "t_fV";
export var svg = "t_fJ";
export var fullscreenButton = "t_fW";
export var playButton = "t_fX";
export var leftNav = "t_fY";
export var rightNav = "t_fZ";
export var imageGallery = "t_f0";
export var fullscreenModal = "t_f1";
export var content = "t_f2";
export var fullscreen = "t_f3";
export var slide = "t_f4";
export var image = "t_f5";
export var left = "t_f6";
export var right = "t_f7";
export var slideWrapper = "t_f8";
export var rtl = "t_f9";
export var slides = "t_gb";
export var center = "t_gc";
export var description = "t_gd";
export var bullets = "t_gf";
export var bulletsContainer = "t_gg";
export var bullet = "t_gh";
export var active = "t_7";
export var thumbnailsWrapper = "t_gj";
export var thumbnailsWrapperRtl = "t_gk";
export var thumbnails = "t_gl";
export var thumbnail = "t_gm";
export var thumbnailsContainer = "t_gn";
export var thumbnailInner = "t_gp";
export var thumbnailImage = "t_gq";
export var thumbnailLabel = "t_gr";
export var index = "t_gs";